import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Button } from "@mui/material";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import { useStore } from "react-redux";
import UserService from "../../services/user-service";
import Icon from "@mui/material/Icon";
import Select from "react-select"

const DialogAjoutUser = (props) => {
  const store = useStore();

  const initialState = {
    name: "",
    firstname: "",
    is_active: false,
    genre: "",
    email: "",
    mobile_phone: "",
    password: "",
    is_profil_ok: false,
    is_password_ok: false,
    profils: []
  };
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState(initialState);
  const [profils] = useState(
    store.getState().referentiel.profils
    .map(p => ({
      ...{
        group_id: p.id,
        profil_name: p.profil_name,
        label: p.profil_name,
        value: p.id,
      },
    })),
  );

  const [type, setType] = useState("password");
  const [iconClass, setIconClass] = useState("fa fa-eye");

  const handleModalClose = () => {
    setShowModal(false);
    props.sendUpdate(true);
  };

  const handleModalShow = () => {
    setUser(initialState);
    setShowModal(true);
  };

  const handleChange = (event) => {
    event.preventDefault();
    const name = event.target.name;
    const value = event.target.value;
    let data = { ...user, [name]: value };
    setUser(data);
  };

  const handleProfilChange = e => {
    setUser({ ...user, profils: e })
  }

  const handleActive = (e) => {
    setUser({ ...user, is_active: e.target.checked });
  };

  const toggleEye = (e) => {
    e.preventDefault();
    if (iconClass === "fa fa-eye") {
      setType("text");
      setIconClass("fa fa-eye-slash");
    } else {
      setType("password");
      setIconClass("fa fa-eye");
    }
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();
    UserService.add(user)
      .then((response) => {
        toast.success(response.data.description, { autoClose: 3000 });
        props.sendUpdate(true);
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.response.data.message, { autoClose: 3000 });
      });
    return;
  };

  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        onClick={handleModalShow}
        className="m-1 text-white"
      >
        + Nouveau
      </Button>
      <Modal show={showModal} onHide={handleModalShow}>
        <AvForm onValidSubmit={handleSubmit}>
          <Modal.Header>
            <Modal.Title className="text-31-secondary">
              <small>Ajouter un nouvel utilisateur</small>
            </Modal.Title>
            <button
              onClick={handleModalClose}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col lg="3">
                <AvField
                  type="select"
                  id="genre"
                  name="genre"
                  value={user.genre}
                  onChange={handleChange}
                  className="form-control"
                  label="Genre"
                >
                  <option hidden>Genre</option>
                  <option value="Homme">Homme</option>
                  <option value="Femme">Femme</option>
                </AvField>
              </Col>
              <Col lg="6">
              <label>Profil</label>
                <Select
                  value={user?.profils}
                  defaultValue={user?.profils}
                  isMulti={true}
                  onChange={handleProfilChange}
                  options={profils}
                  name="profils"
                  id="profils"
                  closeMenuOnSelect={false}
                />
              </Col>
              <Col lg="3">
                <input
                  className="form-check-input"
                  name="is_active"
                  type="checkbox"
                  defaultChecked={user.is_active}
                  onChange={handleActive}
                  id="is_active"
                />
                <label className="form-check-label" htmlFor="is_active">
                  Activer
                </label>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <AvField
                  type="text"
                  className="form-control"
                  name="firstname"
                  id="firstname"
                  value={user.firstname}
                  onChange={handleChange}
                  label="Prénom"
                  errorMessage="Prénom obligatoire"
                  validate={{ required: true }}
                />
              </Col>
              <Col lg="6">
                <AvField
                  type="text"
                  className="form-control"
                  name="name"
                  id="name"
                  value={user.name}
                  onChange={handleChange}
                  label="Nom"
                  errorMessage="Nom obligatoire"
                  validate={{ required: true }}
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <AvField
                  type="email"
                  className="form-control"
                  name="email"
                  id="email"
                  value={user.email}
                  onChange={handleChange}
                  label="Email (identifiant)"
                  errorMessage="Email obligatoire"
                  validate={{ required: true }}
                />
              </Col>
              <Col lg="6">
                <AvField
                  type="text"
                  className="form-control"
                  name="mobile_phone"
                  id="mobile_phone"
                  value={user.mobile_phone}
                  onChange={handleChange}
                  label="Téléphone"
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <AvField
                  type={type}
                  className="form-control"
                  name="password"
                  id="password"
                  value={user.password}
                  onChange={handleChange}
                  label="Mot de passe"
                  errorMessage="Mode de passe obligatoire"
                  validate={{ required: true }}
                />
              </Col>
              <Col lg="2">
                <Icon
                  className={'mt-4 ' + iconClass}
                  fontSize="string"
                  onClick={toggleEye}
                />
              </Col>
              <Col lg="4">&nbsp;</Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="ml-1 mr-1"
            >
              Enregistrer
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleModalClose}
              className="ml-1 mr-1"
            >
              Fermer
            </Button>
          </Modal.Footer>
          <ToastContainer />
        </AvForm>
      </Modal>
    </React.Fragment>
  );
};

export default DialogAjoutUser;
